export default "__VITE_ASSET__BLpU1z2W__"